var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalIconNetsol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_38)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C16 23.1634 23.1634 16 32 16H100C108.837 16 116 23.1634 116 32V100C116 108.837 108.837 116 100 116H32C23.1634 116 16 108.837 16 100V32Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.2229 66.871C33.2229 72.9084 33.2229 79.0212 33.2229 85.0963C33.2229 85.9793 33.4342 86.3038 34.37 86.2585C35.8261 86.1818 37.2857 86.1994 38.7395 86.3113C40.0149 86.4245 40.3093 85.9642 40.3017 84.7567C40.2489 76.4553 40.3017 68.154 40.2489 59.8526C40.1966 58.9014 40.4078 57.9543 40.8592 57.1155C41.3106 56.2766 41.9846 55.5786 42.8072 55.0982C46.3693 52.7587 50.2634 52.653 54.2556 53.5134C55.2323 53.7299 56.1274 54.2194 56.8368 54.9248C57.5462 55.6302 58.0408 56.5226 58.2629 57.498C58.6071 58.7488 58.7722 60.0421 58.7534 61.3393C58.7534 69.2784 58.7534 77.1874 58.7534 85.1567C58.7534 85.9642 58.9043 86.2962 59.8099 86.251C61.4249 86.1679 63.0475 86.1679 64.6625 86.251C65.5983 86.251 65.8247 85.9491 65.8096 85.0661C65.8096 81.3456 65.8096 77.6175 65.8096 73.8895C65.7643 68.6068 65.9907 63.2788 65.636 57.981C65.2662 52.5398 62.2853 48.5024 57.3346 47.2421C53.3044 46.1801 49.0355 46.488 45.1995 48.1175C43.5599 48.7989 42.0332 49.7251 40.6715 50.8645C40.3017 51.1739 40.0527 51.4154 39.781 50.6607C38.9659 48.3967 37.2604 47.3704 34.7021 47.3175C33.5851 47.3024 33.2229 47.6269 33.2229 48.7665C33.2757 54.8039 33.2229 60.8412 33.2229 66.8786V66.871Z",
    fill: "#668B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2733 85.9655C96.4616 84.1241 100.333 79.7018 99.4652 72.5324C99.2566 70.5853 98.4225 68.7582 97.088 67.3252C95.0277 65.0989 92.3939 63.9442 89.5413 63.1216C86.6886 62.2991 83.9567 61.7934 81.3455 60.5256C79.8362 59.7709 78.8853 58.7748 78.7948 57.0239C78.6824 56.1773 78.841 55.3168 79.2477 54.5657C79.6544 53.8147 80.2883 53.2117 81.0588 52.843C83.5219 51.6606 86.3254 51.3931 88.9677 52.0884C91.3585 52.5842 93.5548 53.761 95.2918 55.4768C96.2125 56.3674 96.8012 56.2994 97.3521 55.1825C97.7163 54.4525 98.0241 53.6956 98.2728 52.9185C98.5993 52.183 98.6241 51.3487 98.3418 50.595C98.0596 49.8414 97.4928 49.2287 96.7635 48.8886C91.4053 45.7039 85.7 45.2586 79.8211 47.0321C75.3535 48.398 71.482 51.8544 71.9952 58.1484C72.0915 59.6329 72.5299 61.075 73.2762 62.362C74.0224 63.6489 75.0562 64.7458 76.2968 65.5668C78.5608 67.1742 81.1871 67.8308 83.8435 68.4496C85.8406 68.7809 87.7781 69.4039 89.5941 70.2986C90.6423 70.8068 91.4957 71.6437 92.0243 72.6819C92.5529 73.72 92.7278 74.9025 92.5222 76.0492C92.443 77.024 92.0693 77.9517 91.4506 78.7091C90.832 79.4666 89.9976 80.0181 89.0583 80.2904C84.417 81.9356 80.1683 80.8338 76.0553 78.5169C75.3006 78.0792 74.6893 76.7284 73.7385 77.2944C73.0215 77.7321 72.6895 78.8792 72.2819 79.7546C71.3386 81.7016 71.7688 83.0525 73.5498 84.2222C74.1943 84.6432 74.8858 84.9877 75.61 85.2486C78.4242 86.3078 81.4193 86.8027 84.4246 86.7051C86.4024 86.8032 88.3821 86.5529 90.2733 85.9655Z",
    fill: "#668B22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_38",
    x: 0,
    y: 0,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160156 0 0 0 0 0.211953 0 0 0 0 0.3125 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_38"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_38",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconNetsol);
export default __webpack_public_path__ + "static/media/modal-icon-netsol.1d2bfa934409828dc2bb341bd4d1a8d2.svg";
export { ForwardRef as ReactComponent };